import React, {useEffect, useReducer, useState} from "react";
import ReactTable from "../../components/ReactTableWrapper";
import connection from "../../connection";
import Connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import investiduraStyle from "assets/jss/material-dashboard-pro-react/views/investiduraStyle";
import {faFileExcel, faSearchPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Button from "../../components/CustomButtons/Button";
import EstadoUtilizador from "../../components/EstadoUtilizador";
import useDebounce from "../../functions/useDebounce";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";

function Investidura(props) {
  const {classes} = props

  const [pedidosInvestiduras, setPedidosInvestiduras] = useState(null);
  const [regioesInvestiduras, setRegioesInvestiduras] = useState(null);
  const [regiao_filtrada, setRegiaoFiltrada] = useState(null);
  const [apenas_pendentes, setApenasPendentes] = useState(false);

  const [state, setState] = useReducer(
    (state, newState) => ({...state, ...newState}),
    {
      filter: "",
      page: 0,
      pageSize: 10
    });
  const debouncedFilter = useDebounce(state.filter, 500);

  const obterDados = async () => {
    setPedidosInvestiduras(await connection.get("utilizador/listar_pedidos_investidura", {apenas_pendentes: apenas_pendentes, regiao_filtrada: regiao_filtrada}));
    setRegioesInvestiduras(await connection.get("regiao/listagem"));
  }

  useEffect(() => {
    obterDados();
  }, [apenas_pendentes, regiao_filtrada, debouncedFilter]);

  return (<>
    <div className={classes.investiduraContainer}>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxHeight: "45px"}}>
                <h4 style={{flex: 1}}>Pedidos de Investidura</h4>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={apenas_pendentes}
                      tabIndex={-1}
                      onClick={() => {
                        setApenasPendentes(!apenas_pendentes)
                      }}
                      checkedIcon={<Check className={classes.checkedIcon}/>}
                      icon={<Check className={classes.uncheckedIcon}/>}
                      classes={{
                        checked: classes.checked
                      }}
                    />
                  }
                  classes={{
                    label: classes.label
                  }}
                  label={"Apenas Pendentes de Validação"}
                />
                {general.userHasType("admin", "secretario_regional", "chefe_nacional") && <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
                                                                           target={'_blank'}
                                                                           href={Connection.getFullUrl("utilizador/listar_pedidos_investidura", {apenas_pendentes: apenas_pendentes, regiao_filtrada: regiao_filtrada, exportar_investiduras: true})}>
                  <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
                </a>}
                {general.userHasType("admin", "chefe_nacional") && <FormControl className={classes.selectFormControl} style={{width: "200px"}}>
                  <InputLabel htmlFor="regiao" className={classes.selectLabel} style={{paddingLeft: "10px"}}>
                    Região
                  </InputLabel>
                  <Select
                    style={{margin: "10px", height: "40px"}}
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    onChange={(event) => {
                      setRegiaoFiltrada(event.target.value);
                      return filtrarInvestidurasPorRegiao();
                    }}
                  >
                    <MenuItem value={''} classes={{root: classes.selectMenuItem}}>Selecione a região</MenuItem>
                    {regioesInvestiduras?.map((regiao) => {
                      return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={regiao.id}>{regiao.designacao}</MenuItem>;
                    })}
                  </Select>
                </FormControl>}
              </div>
            </CardHeader>
            <ReactTable
              data={pedidosInvestiduras}
              minRows={1}
              columns={[
                {
                  Header: "Nome",
                  accessor: "nome_curto",
                  maxWidth: 1000,
                  Cell: (row) => <span>
                    <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                      window.App.hist.push("/perfil/" + row.original.id_utilizador);
                    }}>
                    <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/></a>
                  </span>
                },
                {
                  Header: "Agrupamento / Núcleo",
                  accessor: "agrupamento",
                  Cell: (row) => <span>
                    {row.value + (row.original.nucleo ? " / " + row.original.nucleo : '')}
                  </span>
                },
                {
                  Header: "Data Investidura",
                  accessor: "data_investidura",
                  Cell: ({value}) => general.Renderers.dateRenderer(value, {hide_timezone: true})
                },
                {
                  Header: "Estado do Pedido",
                  accessor: "estado_pedido",
                },
                {
                  Header: "",
                  accessor: "actions",
                  sortable: false,
                  maxWidth: 200,
                  Cell: ({original}) => <div>
                    <Button
                      className={classes.button + " " + classes.info}
                      style={{padding: "4px 12px 4px 12px", marginLeft: "10px!important"}}
                      onClick={() => window.App.hist.push("/formulario/pedido_investidura_dirigente?utilizador=" + original.id_utilizador + "&id_percurso=" + original.id_percurso)}
                    >Ver Pedido</Button>
                  </div>
                }
              ]}
              defaultPageSize={10}
              showPaginationBottom={true}
              className="-striped -highlight"
            />
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  </>);
}

export default withStyles(investiduraStyle)(Investidura);